module.exports = __webpack_public_path__ + "static/media/ico_simulation_category_eyes.02a486fd.png";